import { TherapistCardSuccess } from "components/TherapistCardSuccess";
import { Button } from "components/UIKit/Button";
import { useNavigateWithQuery } from "hooks/useNavigateWithQuery";
import { funnelPath } from "pages/Funnel";
import { useMemo, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { therapistProfileService } from "services/therapistProfileService";
import { useSnapshot } from "valtio";
import progressStyles from "../../ProgressForRegistrationFunnel/ProgressForRegistrationFunnel.module.scss";
import styles from "./Success.module.scss";

export const successPath = "/success";

export const Success = () => {
  const [searchParams] = useSearchParams();
  const therapistId = useMemo(
    () => searchParams.get("therapistId"),
    [searchParams]
  );
  const VisitorID = useMemo(
    () => searchParams.get("visitorid"),
    [searchParams]
  );
  const { currentProfile } = useSnapshot(therapistProfileService);
  const navigate = useNavigateWithQuery();
  const goToNextStep = () => navigate(funnelPath);

  const subtitleName = [
    `${currentProfile?.user.first_name} ${currentProfile?.user.last_name}`,
    currentProfile?.credentials_choice?.toUpperCase(),
  ]
    .filter((item) => item)
    .join(", ");
  // This will trigger the conversion
  // This will trigger the conversion
  window.gtag("event", "conversion", {
    send_to: "AW-11025675463/UTgYCOmpw4kYEMfpuYkp",
  });
  return (
    <div className="default-typography">
      <div className="row justify-content-center">
        <div className="col-xs-10 col-md-8">
          <div
            className="text-center mb-40 mb-sm-60"
            ref={(node) =>
              node?.style.setProperty("margin-bottom", "56px", "important")
            }
          >
            <h4
              className="mb-0"
              style={{ fontSize: "22px", textAlign: "center" }}
            >
              {" "}
              Thank you, your ESA therapist {subtitleName}, has received your
              information. Please continue to get your ESA Letter.
            </h4>
          </div>
        </div>
      </div>

      <div className={progressStyles.sectionProgress__content}>
        <div className={progressStyles.sectionProgress__progressBlock}>
          <div
            className={progressStyles.sectionProgress__progressStrip}
            style={{ width: "30%" }}
          ></div>
        </div>
      </div>

      <div className="d-flex justify-content-center">
        {currentProfile && <TherapistCardSuccess therapist={currentProfile} />}
      </div>
      <div className="d-flex justify-content-center p-20">
        <div className="text-center">
          <Button
            className="w-100"
            onClick={() =>
              navigate(
                `${funnelPath}`,
                `therapistId=${therapistId}&visitorid=${VisitorID}`
              )
            }
          >
            Continue
          </Button>
        </div>
      </div>
    </div>
  );
};
